import { DASHOARD_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminDashboardService = {
  getAll: () => requests.get(`${DASHOARD_URL}`),
};
